import React from "react";
import { CostumeSet } from "../../lib/costumes/Costume";
import CostumeUISelector from "./CostumeUISelector";
import "./CostumeUI.scoped.scss";
import background1 from "../../img/costumes/closet_1.png";
import background2 from "../../img/costumes/closet_2.png";

interface Props {
  costumes: CostumeSet;
  setCostumes: React.Dispatch<React.SetStateAction<CostumeSet>>;
}

type Tab =
  | "髪型"
  | "眉"
  | "目"
  | "口"
  | "腕"
  | "服装"
  | "帽子"
  | "小物"
  | "背景";
const tabs: Tab[] = [
  "髪型",
  "眉",
  "目",
  "口",
  "腕",
  "服装",
  "帽子",
  "小物",
  "背景",
];

export default function CostumeUI({ costumes, setCostumes }: Props) {
  const [selectedTab, setTab] = React.useState<Tab>("髪型");
  const [background, setBackground] = React.useState<string>();

  const setupBackground = () => {
    const { innerWidth: width } = window;
    if (width > 540) {
      setBackground(background1);
    } else {
      setBackground(background2);
    }
  };
  React.useEffect(() => {
    setupBackground();
    window.addEventListener("resize", setupBackground);
    return () => window.removeEventListener("resize", setupBackground);
  }, []);

  return (
    <div className="costume-ui">
      <img src={background} alt="bg" />
      <div className="costume-ui-content">
        <div className="dummy-wrapper">
          <div className="dummy-content"></div>
        </div>
        <div className="tabs">
          {tabs.map((tab) => (
            <div
              key={tab}
              className={"tab" + (tab === selectedTab ? " selected" : "")}
              onClick={() => {
                setTab(tab);
              }}
            >
              {tab}
            </div>
          ))}
        </div>
        <div className="panel">
          {(() => {
            switch (selectedTab) {
              case "髪型":
                return (
                  <CostumeUISelector
                    category="髪型"
                    costumes={costumes}
                    setCostumes={setCostumes}
                  ></CostumeUISelector>
                );
              case "眉":
                return (
                  <CostumeUISelector
                    category="眉"
                    costumes={costumes}
                    setCostumes={setCostumes}
                  ></CostumeUISelector>
                );
              case "目":
                return (
                  <>
                    <h3>種類</h3>
                    <CostumeUISelector
                      category="目"
                      costumes={costumes}
                      setCostumes={setCostumes}
                    ></CostumeUISelector>
                    <h3>目の色</h3>
                    <CostumeUISelector
                      category="目の色"
                      costumes={costumes}
                      setCostumes={setCostumes}
                    ></CostumeUISelector>
                  </>
                );
              case "口":
                return (
                  <CostumeUISelector
                    category="口"
                    costumes={costumes}
                    setCostumes={setCostumes}
                  ></CostumeUISelector>
                );
              case "腕":
                return (
                  <CostumeUISelector
                    category="腕"
                    costumes={costumes}
                    setCostumes={setCostumes}
                  ></CostumeUISelector>
                );
              case "服装":
                return (
                  <CostumeUISelector
                    category="服装"
                    costumes={costumes}
                    setCostumes={setCostumes}
                  ></CostumeUISelector>
                );
              case "帽子":
                return (
                  <CostumeUISelector
                    category="帽子"
                    costumes={costumes}
                    setCostumes={setCostumes}
                  ></CostumeUISelector>
                );
              case "小物":
                return (
                  <>
                    <h3>メガネ</h3>
                    <CostumeUISelector
                      category="メガネ"
                      costumes={costumes}
                      setCostumes={setCostumes}
                    ></CostumeUISelector>
                    <h3>耳飾り</h3>
                    <CostumeUISelector
                      category="耳飾り"
                      costumes={costumes}
                      setCostumes={setCostumes}
                    ></CostumeUISelector>
                    <h3>その他</h3>
                    <CostumeUISelector
                      category="小物"
                      costumes={costumes}
                      setCostumes={setCostumes}
                    ></CostumeUISelector>
                  </>
                );
              case "背景":
                return (
                  <CostumeUISelector
                    category="背景"
                    costumes={costumes}
                    setCostumes={setCostumes}
                  ></CostumeUISelector>
                );
              default:
                return <></>;
            }
          })()}
        </div>
      </div>
    </div>
  );
}
